import type { GetStaticProps, NextPage } from 'next'

import { AboutPage, AboutPageProps } from 'src/App/AboutPage/AboutPage'
import { strapiGetStories } from 'src/strapi/api/getStories'
import { StoryClientType } from 'src/strapi/types/storiesTypes'

const About: NextPage<AboutPageProps> = (props) => <AboutPage {...props} />

export const getStaticProps: GetStaticProps = async () => {
  const stories: Array<StoryClientType> = []

  try {
    const fetchedStories = await strapiGetStories({
      withImages: true,
      page: 1,
      pageSize: 6,
    })
    stories.push(...fetchedStories)

    if (!stories.length) {
      throw new Error('Stories were not received')
    }
  } catch (error) {
    console.log('Failed to build about page /about', error as Error)
  }

  return {
    revalidate: false,
    props: {
      stories,
    },
  }
}

export default About
